import { Location } from '@angular/common';
import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild, Input } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators, UntypedFormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { takeUntil } from 'rxjs/operators'; import { Subject } from 'rxjs';
import { ExaminationSupply, ExaminationSupplyDetails, ExaminationSupplyMaster } from './examination-supply';
//shared libs
import { ModalService, ControlsComponent, Message, SelectizeComponent, ToastService, AppCodes, TabComponent } from '../../blocks';
import { AppCodeGroup, ControlsParams, SharedDateService, StockParms, UserSessionService, StockParmsSpesial, StockModuleSettingsParms } from '../../shared';

//services
import { ExaminationSupplyListComponent } from './examination-supply-list.component';
import { ExaminationSupplyService } from './examination-supply.service';
import { TranslateService } from '@ngx-translate/core';
import { poOrderSupplyDetailService } from '../po-order-supply/po-order-supply.service';
import { DirectAddFromSupplyOrderOrRequstNeedComponent } from '../../stock-transaction/dirct-add-from-supplyorder-or-requestneed/dirct-add-from-supplyorder-or-requestneed.component';
import { GenStockTransService } from '../../stock-transaction/stock-transaction-interface/gen-stock-transaction.service';
import { PoOrderSupplyComponent } from '../po-order-supply';
import { StockPoHelper } from '../stock-po.helper';
import { AlertApprovCycleTransComponent } from '../../personnel-setup/alert-approv-cycle-trans/alert-approve-cycle-trans.component';
import { StoreExaminationCommitteeStpService } from '../../inventory/store-examination-committee-stp/store-examination-committee-stp.service';
import { StockHelper } from '../../stock-trans-exchange-outpatient/stock-trans-exchange-outpatient-help/stock-outpatient.helper';
// import { rootRenderNodes } from '@angular/core/src/view';

@Component({
  selector: 'app-examination-supply',
  templateUrl: './examination-supply.component.html',
  styleUrls: ['./examination-supply.component.css']

})

export class ExaminationSupplyComponent implements OnInit, AfterViewInit, OnDestroy {
  showQeq: number = 0;
  //activeTabSerial: number = 2424;
  toggleApprovedList: boolean;

  showComponnet: number = 0;
  PoSupplyList: number = 0;
  items = [];
  controlsParams: ControlsParams;
  ExaminationSupplyForm: UntypedFormGroup;
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  @Input() ExamminationSupplyObj: any;
  @ViewChild('btnCtrl1') btnCtrl1: any;////////////-------------------------------------
  @ViewChild('storeByUser') storeByUser: SelectizeComponent;
  @ViewChild('itemMainData') itemMainData: SelectizeComponent;
  @ViewChild('ExaminationSupplyListComponent') ExaminationSupplyListComponent: ExaminationSupplyListComponent;
  @ViewChild('tabCtrl') tabCtrl: TabComponent;
  @Input() UITreeKey: string;
  poOrderSupplierCode: number;
  tabsData: any;
  fromDash: boolean = false;
  @ViewChild('content') content: any;//===============================================/////
  _StockParms = <StockParms>{};//============_StockParms===================================/////
  itemUnits = [];
  stockModuleSettings: {};
  itemsInPoOrderSupplyListObj: {};
  dynamicComponent: any;
  addTaxToItemCostSetting: number;
  defaultDiscountAttributes: number;
  directAddFromExamination: number;
  temp = [];
  tempo = [];
  linkId: number;
  poOrderSupplyList = [];
  selectAll: any;
  itemsInPoOrderSupplyList = [];
  mode: number;
  placHolder: string;
  myCompOneObj: any;
  defaultDiscountAttribute: number;
  DirectAddTransForm: UntypedFormGroup;
  stockPo: StockPoHelper;
  alertSerial: number;
  enableDecision;
  selectexaminationCommitteeEmps: number;
  makeExaminationWithoutOrderSupply: number;
  storeActiveExpirationDate: boolean;
  hiddenQuantityFromExamination: number;
  constructor(
    private _ExaminationSupplyServiceService: ExaminationSupplyService,
    public translate: TranslateService,
    private _poOrderSupplyDetailService: poOrderSupplyDetailService,
    private _fb: UntypedFormBuilder,
    private _modalService: ModalService,
    private _route: ActivatedRoute,
    private _router: Router,
    private _location: Location,
    private _DirectAddTransService: GenStockTransService,
    private _toastService: ToastService,
    private _userSessionService: UserSessionService,
    private _dateService: SharedDateService,
    private _StoreExaminationCommitteeStpService: StoreExaminationCommitteeStpService,
    public _StockHelper: StockHelper,

  ) {
    this.myCompOneObj =
      new DirectAddFromSupplyOrderOrRequstNeedComponent(_DirectAddTransService, _toastService, _modalService, _userSessionService, _dateService, _fb);
    this.controlsParams = new ControlsParams(3120, AppCodeGroup.Buttons, true);
    this.stockPo = new StockPoHelper(_toastService);
  }


  ngOnInit() {
    this.getModuleSettings();
    this.UITreeKey = this.UITreeKey || '0';
    //this.activeTabSerial = 2424;
    this.DirectAddTransInit();
    const taxNatureValue = this._userSessionService.getSessionKey<any>('taxNatureValue');
    this.ExamminationSupplyObj = this._userSessionService.getSessionKey<any>('ExamminationSupplyObj')
    if (this._userSessionService.getSessionKey<any>('poTotalTaxMoneyCode')) {
      let poTotalTaxMoney = this._userSessionService.getSessionKey<any>('poTotalTaxMoneyCode');
      this.DirectAddTransForm.get('poTotalTaxMoney').setValue(poTotalTaxMoney);
    }
    if (this.ExamminationSupplyObj) {
      this.DirectAddTransForm.patchValue(this.ExamminationSupplyObj)///to patcj value of exammination suplly
      this.DirectAddTransForm.get('supplierCode').setValue(this.ExamminationSupplyObj['supSupplierCode']);
      if (taxNatureValue != (undefined || null)) {
        this.DirectAddTransForm.get('taxType').setValue(taxNatureValue);
      }
    }
    this.ExaminationSupplyInit();
    //_____________________________________________________________//
    this._userSessionService.subscribeToKey$('orderExaminationSession').pipe(
      takeUntil(this.ngUnsubscribe))
      .subscribe((keys: any) => {
        if (keys.name == 'orderExaminationSession' && keys.value) {
          this.alertSerial = keys.value;
          this.fromDash = true;
          this._StockParms.serial = keys.value;
          this.getExaminationDetails(this._StockParms);
        }
      });
    //_________________________________________________________________________
    if (this._userSessionService.getSessionKey<any>('link')) {
      let link = this._userSessionService.getSessionKey('link');
      this.linkId = link['code']
      this.mode = +this._route.snapshot.params['mode'];
      this.tabsData = new ControlsParams(link['code'], AppCodeGroup.Tabs, true);
    }

    if (this.mode == 1) {
      this.placHolder = 'Pharmacy'
    }
    if (this.mode == 2) {
      this.placHolder = 'STORE'
    }
    if (this.mode == 3) {
      this.placHolder = 'ASSETS'
    }
    if (this.mode == 4) {
      this.placHolder = 'BLOODBANK'
    }
    if (this.mode == 5) {
      this.placHolder = 'THECAFETERIA';
    }


    this._userSessionService.subscribeToKey$('DecisionStatus').pipe(
      takeUntil(this.ngUnsubscribe))
      .subscribe((keys: any) => {
        if (keys && keys.value) {
          this.enableDecision = true
          if (keys.value == 1) {
            this.DirectAddTransForm.get('agree').setValue(true)
          }
          else if (keys.value == 2) {
            this.DirectAddTransForm.get('disagree').setValue(true)
          }
        }
      });
  }

  getNetOfPiceitemAndTotalSale(items) {
    let sum: number = 0;
    let formTotalCost: number = 0
    items.forEach((row) => {
      row['netOfPiceitem'] = row['unitSale'] * row['number']
      sum = sum + row['netOfPiceitem']
      formTotalCost = formTotalCost + row['totalCost']
    });
    this.DirectAddTransForm.get('totalSale').setValue(sum)
    this.DirectAddTransForm.get('totalCost').setValue(formTotalCost)
    if (!this.DirectAddTransForm.get('totalNetCost').value) {
      this.DirectAddTransForm.get('totalNetCost').setValue(formTotalCost)
    }
    this.DirectAddTransForm.get('grossTotalCost').setValue(formTotalCost)
  }
  DirectAddTransInit() {
    let date = this._dateService.convertFromDateToNgBsObject(new Date());
    this.DirectAddTransForm = this._fb.group({
      tranSerial: new UntypedFormControl(),
      storeCode: new UntypedFormControl('', Validators.required),
      transType: new UntypedFormControl(),
      totalCost: new UntypedFormControl(),
      totalSale: new UntypedFormControl(),
      handNumber: new UntypedFormControl(),
      notes: new UntypedFormControl(),
      supplierCode: new UntypedFormControl('', Validators.required),
      billNo: new UntypedFormControl(),
      transDate: date,
      taxType: new UntypedFormControl('', Validators.required),
      transCode: new UntypedFormControl(),
      discount: new UntypedFormControl(),
      discountType: new UntypedFormControl(),
      masterAdditionalDiscountOutTax: new UntypedFormControl(),
      masterAdditionalDiscountType: new UntypedFormControl(),
      totalNetCost: new UntypedFormControl(),
      grossTotalCost: new UntypedFormControl(),
      discountInclusion: new UntypedFormControl(2, Validators.required),
      customCodeItem: new UntypedFormControl(),
      barcodeItem: new UntypedFormControl(),
      poTotalTaxMoney: new UntypedFormControl(),
      agree: new UntypedFormControl(),
      disagree: new UntypedFormControl()
    })

  }
  showAppoval() {
    this.toggleApprovedList = true;
    this.dynamicComponent = AlertApprovCycleTransComponent;
    this._userSessionService.setSessionKey('RequestAlertSerial', { alertSerial: this.alertSerial, requestType: 'EXAMINATION_ORDER' })
    this.content.openModal("AlertApprovCycleTransComponent", "alertSerial", this.alertSerial);
  }
  statusCheck() {

  }
  //--------------------------------assets------------------------------------------
  onAssetsClick($event) {
    if ($event) {
      $event.giftFlag = true
      this.items.push($event);
    }
  }
  onAssetsItemFromExaminationClick($event) {
    if ($event) {
      $event.giftFlag = true
      this.items.push($event);
    }
  }
  supscribeData() {

    let xxx = this._userSessionService.getSessionKey('link')
    if (this.storeByUser) {
      this.storeByUser.clear();
      this.storeByUser.clearItems();
      this.storeByUser.setFastSearchObjDynamicKey('Type', xxx['mode']);
      if (xxx && xxx['code'] == 6578) {
        this.storeByUser.setFastSearchObjDynamicKey('Assets', true);
      }

    }
    if (this.itemMainData) {
      this.itemMainData.clear();
      this.itemMainData.clearItems();
      this.itemMainData.setFastSearchObjDynamicKey('Type', xxx['mode']);
    }
    this._userSessionService.getSessionKey$('link')
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((keys: any) => {
        if (keys.value) {
          if (this.storeByUser) {
            this.storeByUser.clear();
            this.storeByUser.clearItems();
            this.storeByUser.setFastSearchObjDynamicKey('Type', keys.value['mode']);
            if (xxx && xxx['code'] == 6578) {
              this.storeByUser.setFastSearchObjDynamicKey('Assets', true);
            }
          }
          if (this.itemMainData) {
            this.itemMainData.clear();
            this.itemMainData.clearItems();
            this.itemMainData.setFastSearchObjDynamicKey('Type', keys.value['mode']);
          }
          this.NewExamination();
          let link = this._userSessionService.getSessionKey('link');
          this.linkId = link['code']
        }
      });
  }
  activateTab(tabData: AppCodes) {
    this.queryVisitedUI('tabData.serial');

    this.queryUIKey('tabData.serial');
    //this.activeTabSerial = tabData.serial;
    if (this.queryUIKey('2425')) {
      this.GetRequestList();
    }
    if (this.queryUIKey('2424')) {
      //this.NewExamination();

    }
  }

  onStoreClick($event) {
    if (this.itemMainData && $event) {
      this.storeActiveExpirationDate = $event.activeExpirationDate
      this.itemMainData.setFastSearchObjDynamicKey('StoreCode', $event.code)
    }
  }

  onSupSupplierClick(event) {
    if (event && event != (undefined || null))

      this.showQeq = 1;

    this.poOrderSupplyList = [];
    this.itemsInPoOrderSupplyList = [];
    if (event != (undefined || null) && event.code) {
      this._StockParms.supplierCode = event.code

    }
    let mode = this._userSessionService.getSessionKey('link')['mode'];

    if (mode && mode == 3) {
      this._StockParms.itemType = 3;

    }
    if (mode && mode == 2) {
      this._StockParms.itemType = 2;
    }
    if (mode && mode == 1) {
      this._StockParms.itemType = 1;
    }
    this._StockParms.queryCode = 3;


    this._StockParms.storeCode = this.ExaminationSupplyForm.get('storeCode').value;
    this._ExaminationSupplyServiceService.getPoOrderSupply(this._StockParms, '')
      .subscribe(
        poOrderSupplyList => {
          if (poOrderSupplyList.data)
            this.poOrderSupplyList = poOrderSupplyList.data;
          this.poOrderSupplyListCopy = poOrderSupplyList.data;
        },
        error => console.log(error),
        () => {
          null
        });



  }

  GetRequestList() {
    this.showQeq = 1;
  }
  NewExamination() {
    let date = this._dateService.convertFromDateToNgBsObject(new Date());
    this.ExaminationSupplyForm.get('examinationDate').setValue(date);
    this.ExaminationSupplyForm.get('serial').setValue(0);
    this.items = [];
    this.itemUnits = [];
    this.temp = [];
    this.tempo = [];
    this.poOrderSupplyList = [];
    this.itemsInPoOrderSupplyList = [];


  }
  ngAfterViewInit() {
    this.supscribeData();
    this.queryVisitedUI('2424');
    this.queryUIKey('2424')
    this._userSessionService.setBtnCtrl(this.btnCtrl1);
    this.DirectAddTransForm.get('discountInclusion').setValue(this.defaultDiscountAttribute);
  }
  approvalStatus: number;
  poOrderSupplyListCopy: any[] = [];
  onApprovalStatusClick(event: any) {
    if (event) {
      this.approvalStatus = event.code;
      this.poOrderSupplyList = [];
      if (this.approvalStatus == 1) {
        this.poOrderSupplyList = this.poOrderSupplyListCopy.filter(e => e.approvalStatus == 1 || e.approvalStatus == 100)

      } else if (this.approvalStatus == 2) {
        this.poOrderSupplyList = this.poOrderSupplyListCopy.filter(e => e.approvalStatus == 2)

      }
      else if (this.approvalStatus == 3) {
        this.poOrderSupplyList = this.poOrderSupplyListCopy.filter(e => e.approvalStatus !== 1 || e.approvalStatus !== 100)

      }
      else {
        this.poOrderSupplyList = this.poOrderSupplyListCopy;

      }

    }
  }
  selectAlll() {
    if (this.selectAll == true) {
      for (var i = 0; i < this.itemsInPoOrderSupplyList.length; i++) {
        this.itemsInPoOrderSupplyList[i].selected = true;
      }
      this.items = [];
      this.tempo = [];
      this.itemUnits = [];
      this.items = this.itemsInPoOrderSupplyList;
      for (var i = 0; i < this.items.length; i++) {
        this.items[i].supplyQty = this.items[i].number;
        this.items[i].acceptQty = this.items[i].number;
        this.items[i].rejectQty = 0;

        this.tempo.push(this.items[i].code);
      }
      if (this.tempo.length > 0)
        this._ExaminationSupplyServiceService.getItems(this.tempo.toString())
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(c => {
            this.itemUnits = c.data;
          });
    }
    else if (this.selectAll == false) {
      for (var i = 0; i < this.itemsInPoOrderSupplyList.length; i++) {
        this.itemsInPoOrderSupplyList[i].selected = false;
        this.items = [];
      }
    }
  }
  onRowIconClick2(ev, row) {
    if (row) {
      this.items = [];
      this.itemUnits = [];
      this.temp = [];
      this.tempo = [];
      this.getExaminationCommitteeForStore();
      // ---------------------------------------------------------
      let comitteeData: any = {};
      comitteeData.po = row;
      comitteeData.comitteeEmps = this.examinationCommitteeEmps;
      this._userSessionService.setSessionKey("POORDERSUPPLYSERIAL", comitteeData)
      //-----------------------------------------------------------
      this.itemsInPoOrderSupplyList = [];
      this._StockParms.serial = row.serial
      this._StockParms.queryCode = 1;
      this.poOrderSupplierCode = row.serial
      if (row && row['poOrderType'] == 3) {
        var notes = 'Assets'
      }
      else {
        var notes = ''
      }
      //assets
      if (this.mode && this.mode == 3) {
        this._StockParms.queryCode = 7;
      }
      this._ExaminationSupplyServiceService.getPoOrderSupply(this._StockParms, notes)
        .subscribe(
          itemsInPoOrderSupplyList => {
            if (itemsInPoOrderSupplyList.data) {
              this.itemsInPoOrderSupplyList = itemsInPoOrderSupplyList.data;
              this.itemsInPoOrderSupplyListObj = this.itemsInPoOrderSupplyList[0];
            }
          },
          error => console.log(error),
          () => {
            null
          });

    }
  }



  OnSelectItem(row) {

    if (row.selected == true) {
      this.tempo = [];

      if (this.items.find(x => x.code == row["code"])) {
        return false;
      }
      else {
        this.items = this.items.concat(row)
      }

      //this.items.push(row);

      for (var i = 0; i < this.items.length; i++) {
        this.tempo.push(this.items[i].code);
        this.items[i].supplyQty = this.items[i].number;
        this.items[i].acceptQty = this.items[i].number;
        this.items[i].rejectQty = 0;

      }
      if (this.tempo.length > 0)
        this.tempo = this.tempo.filter((v, i, a) => a.indexOf(v) === i);
      this._ExaminationSupplyServiceService.getItems(this.tempo.toString())
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(c => {
          this.itemUnits = c.data;
        },
          error => console.log(error),
          () => {
            null
          });

    }
    else {
      let ind = this.items.indexOf(row);
      this.items.splice(ind, 1);
    }
  }

  fromDashAleretObj: any = {};
  getExaminationDetails(event: any) {
    this.items = [];
    this.showComponnet = 1;
    if (event)
      var temp = [];

    var prem: StockParmsSpesial = {
      serial: event.serial
    }
    temp.push(prem);
    this._ExaminationSupplyServiceService.getExaminationSupply(temp)
      .subscribe(
        request => {
          this.items = [];
          this.ExaminationSupplyForm.patchValue(request.data[0])
          this.fromDashAleretObj = request.data[0];
          let examinationDate = this._dateService.convertFromDateToNgBsObject(request.data[0].examinationDate);
          this.ExaminationSupplyForm.get('examinationDate').setValue(examinationDate)
          this.items = request.data2;

        },
        error => console.log(error),
        () => {

          if (!this.fromDash) {
            this.storeByUser.setFastSearchObjDynamicKey('Type', 0)
          }
          // else { 
          // this.storeByUser.setFastSearchObjDynamicKey('Type', 0)
          // };
          if (this.items.length > 0)
            this.tempo = [];
          for (var i = 0; i < this.items.length; i++) {
            this.tempo.push(this.items[i].code);
          }
          if (this.tempo.length > 0)
            this._ExaminationSupplyServiceService.getItems(this.tempo.toString())
              .pipe(takeUntil(this.ngUnsubscribe))
              .subscribe(c => {
                this.itemUnits = c.data;

              },
                error => console.log(error),
                () => {
                  if (this.tabCtrl) {
                    this.queryVisitedUI('2424');

                    this.queryUIKey('2424')
                    this.tabCtrl.gotoTabOfAppcode(2424)

                  }
                });


        });
  }
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
  // initialize ExaminationSupplyInit form
  ExaminationSupplyInit() {
    let date = this._dateService.convertFromDateToNgBsObject(new Date());
    this.ExaminationSupplyForm = this._fb.group({
      serial: new UntypedFormControl(-1),
      supSupplierCode: new UntypedFormControl('', Validators.required),
      poOrderSupplierCode: new UntypedFormControl(),
      storeCode: new UntypedFormControl('', Validators.required),
      status: new UntypedFormControl(1),
      poTotalTaxMoney: new UntypedFormControl(),
      handNumber: new UntypedFormControl(),
      examinationDate: date,
    })
    this.ExaminationSupplyForm.get('status').setValue(1)
  }


  onClicked(e: number): void {
    switch (e) {
      case 1: //save code
        this.save();
        break;

      default:
        this.cancel();
    }
  }

  printExam(examSup) {
    if (examSup) {
      this._userSessionService.setSessionKey("ExaminationSupply", examSup);

      this.queryVisitedUI('1013');
      this.queryUIKey('1013')
      this.tabCtrl.gotoTabOfAppcode(1013);

    }
  }
  changes: any
  onAcceptQtyChange(event, row) {
    if (row)
      if (+row["acceptQty"] > +row["supplyQty"]) {
        this._toastService.activateMsg('UI13');
        return;
      }
    if (row && (row["supplyQty"] != "" || row["supplyQty"] != (undefined || null))) {
      row["rejectQty"] = row["supplyQty"] - row["acceptQty"]
      row['number'] = row["supplyQty"];
    }

    this.changes = this.stockPo.onNuberChange(event, row, {
      defaultDiscountAttribute: this.defaultDiscountAttributes,
      addTaxToItemCostSetting: this.addTaxToItemCostSetting
    }, this.items);
    row = this.changes.row;
    console.log(this.changes);
    for (let key in this.changes.customObj) {
      if (this.changes.customObj[key])
        this.DirectAddTransForm.get(key).setValue(this.changes.customObj[key])
    }
  }

  onSupplyQtyQtyChange(event, row) {
    if (row && (row["supplyQty"] > row["remain"])) {
      this._toastService.activateMsg('UI111');
      return;

    }
  }
  itemUnitsFactorDesc = [];
  getFactorDesc(itemCode) {
    if (this.itemUnitsFactorDesc && this.itemUnitsFactorDesc.length > 0) {
      let desc = this.itemUnitsFactorDesc.find(x => x.itemCode == itemCode)
      if (desc && desc['itemUnitFactor'])
        return desc['itemUnitFactor'];
    }
  }
  addDirectItemFromExamination(item) {
    item.forEach((el, i) => {
      el.index = i;
    });
    this.tempo = [];
    for (var rr = 0; rr < item.length; rr++) {
      // item[rr]['giftFlag'] = true;
      // item[rr]['gift'] = true;
      item[rr]['customID'] = item[rr]['customCode']
      item[rr]['reasonOfReject'] = item[rr]['reasonOfReject']
      this.items = this.items.concat(item[rr])
    }
    for (var i = 0; i < this.items.length; i++) {
      var prem: StockParms = {
        itemCode: this.items[i].code,
        notes: 'PurchesUnits'

      }
      this.tempo.push(prem);

    }
    if (this.tempo.length > 0)
      this._poOrderSupplyDetailService.itemsLoad(this.tempo)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(c => {


          if (c && c.data && c.data.length > 0) {
            this.itemUnits = c.data;
          }

          if (c && c.data2 && c.data2.length > 0) {
            this.itemUnitsFactorDesc = c.data2;
          }

        },
          error => console.log(error),
          () => {

            if (this.itemUnits && this.itemUnits.length > 0) {
              for (var i = 0; i < this.items.length; i++) {
                let unitValue = this.getUnitsByItemCode(this.itemUnits, this.items[i]['code']);
                if (unitValue && unitValue.length > 0) {
                  var maxFactor = 0;
                  if (this.defaultDiscountAttribute == 1)
                    this.items[i].tax = 0;
                  for (let index = 0; index < unitValue.length; index++) { // to get large factor
                    var element = unitValue[index]['factor'];
                    if (element && element >= maxFactor) {
                      maxFactor = element
                    }
                  }
                  let largeunitVal = this.getUnitLargeValueByFactore(unitValue, maxFactor);;
                  if (largeunitVal && largeunitVal.length > 0) {
                    this.items[i]['unitCost'] = largeunitVal[0]["purchasePrice"];;;; // ده سعر الوحده
                    this.items[i]['unitSale'] = largeunitVal[0]["salePrice"];;;; // ده سعر الوحده
                    this.items[i]['unitCode'] = largeunitVal[0]["serial"]; // ده سعر الوحده
                  }
                }
              }
            }
          });
  }
  addItem(item) {
    item.forEach((el, i) => {
      el.index = i;
    });
    this.tempo = [];
    for (var rr = 0; rr < item.length; rr++) {
      item[rr]['giftFlag'] = true;
      item[rr]['gift'] = true;
      item[rr]['customID'] = item[rr]['customCode']
      item[rr]['reasonOfReject'] = item[rr]['reasonOfReject']
      this.items = this.items.concat(item[rr])
    }
    for (var i = 0; i < this.items.length; i++) {
      var prem: StockParms = {
        itemCode: this.items[i].code,
        notes: 'PurchesUnits'

      }
      this.tempo.push(prem);

    }
    if (this.tempo.length > 0)
      this._poOrderSupplyDetailService.itemsLoad(this.tempo)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(c => {


          if (c && c.data && c.data.length > 0) {
            this.itemUnits = c.data;
          }

          if (c && c.data2 && c.data2.length > 0) {
            this.itemUnitsFactorDesc = c.data2;
          }

        },
          error => console.log(error),
          () => {

            if (this.itemUnits && this.itemUnits.length > 0) {
              for (var i = 0; i < this.items.length; i++) {
                let unitValue = this.getUnitsByItemCode(this.itemUnits, this.items[i]['code']);
                if (unitValue && unitValue.length > 0) {
                  var maxFactor = 0;
                  if (this.defaultDiscountAttribute == 1)
                    this.items[i].tax = 0;
                  for (let index = 0; index < unitValue.length; index++) { // to get large factor
                    var element = unitValue[index]['factor'];
                    if (element && element >= maxFactor) {
                      maxFactor = element
                    }
                  }
                  let largeunitVal = this.getUnitLargeValueByFactore(unitValue, maxFactor);;
                  if (largeunitVal && largeunitVal.length > 0) {
                    this.items[i]['unitCost'] = largeunitVal[0]["purchasePrice"];;;; // ده سعر الوحده
                    this.items[i]['unitSale'] = largeunitVal[0]["salePrice"];;;; // ده سعر الوحده
                    this.items[i]['unitCode'] = largeunitVal[0]["serial"]; // ده سعر الوحده
                  }
                }
              }
            }
          });
  }
  getUnitLargeValueByFactore(units: Array<any>, factor: number): Array<any> {
    return units.filter(item => item.factor == factor);
  }
  getUnitsByItemCode(units: Array<any>, itemCode): Array<any> {

    return units.filter(item => item.itemId == itemCode);
  }
  getSmallUnit(units: Array<any>, itemCode): Array<any> {
    return units.filter(item => item.factor == 1 && item.itemId == itemCode);
  }
  saveExmaination() {
    this.CheckQty();
    if (this.ExaminationSupplyForm.get('storeCode').value == (undefined || null)) {
      this._toastService.activateMsg('UI64');
      return;
    }
    this._userSessionService.setSessionKey("ExaminationSupplyResetPrint", 1);
    let examinationSupplys = [];
    for (var i = 0; i < this.items.length; i++) {
      let examinationSupplyDetails = <ExaminationSupplyDetails>{};
      examinationSupplyDetails.serial = (this.items[i].examSerial ? this.items[i].examSerial : (i + 1) * -1)
      if ((this.items[i].remain == (undefined || null)) ||
        (this.items[i].rejectQty == (undefined || null)) ||
        (this.items[i].acceptQty == (undefined || null)) ||
        (this.items[i].supplyQty == (undefined || null))) {
        this._toastService.activateMsg("UI31", this.items[i].code);
        return false;
      }
      if (this.items[i].reasonOfReject == null && this.items[i].rejectQty > 0) {
        this._toastService.activateMsg("UI31", this.items[i].code);
        return false;
      }
      if (this.items[i] && (+this.items[i]["supplyQty"] > +this.items[i]["remain"])) {
        this._toastService.activateMsg('UI111', this.items[i].code);
        return;
      }
      if (+this.items[i]["acceptQty"] > +this.items[i]["supplyQty"]) {
        this._toastService.activateMsg('UI13', this.items[i].code);
        return;
      }
      examinationSupplyDetails.itemCode = this.items[i].code;
      examinationSupplyDetails.quantity = +this.items[i].remain;
      examinationSupplyDetails.rejectQty = +this.items[i].rejectQty;
      examinationSupplyDetails.acceptQty = +this.items[i].acceptQty;
      examinationSupplyDetails.supplyQty = +this.items[i].supplyQty;
      examinationSupplyDetails.unitCode = this.items[i].unitCode;
      examinationSupplyDetails.giftFlag = this.items[i].giftFlag;
      examinationSupplyDetails.remain = +this.items[i].remain;
      examinationSupplyDetails.reasonOfReject = this.items[i].reasonOfReject;
      examinationSupplyDetails.patchCodeStr = this.items[i].patchCodeStr;
      /// calculate samll unit
      let smaillUnit = this.getSmallUnit(this.itemUnits, this.items[i].code);
      if (smaillUnit && smaillUnit.length > 0) {
        examinationSupplyDetails.smallUnitCode = smaillUnit[0].serial;
      }
      if (this.makeExaminationWithoutOrderSupply != 1 && this.items[0].poOrderSupplyMasterSerial == (undefined || null)) {
        this._toastService.activateMsg('UI175', this.items[i].code);
        return;
      }
      examinationSupplyDetails.poOrderSupplyMasterSerial = this.items[0].poOrderSupplyMasterSerial;
      examinationSupplys.push(examinationSupplyDetails);
    }
    //master
    let examinationSupplyMaster = <ExaminationSupplyMaster>{};
    let examinationDate = this._dateService.convertFromNgBsToDate(this.ExaminationSupplyForm.get('examinationDate').value);
    this.ExaminationSupplyForm.get('status').setValue(1);
    examinationSupplyMaster = this.ExaminationSupplyForm.value;
    examinationSupplyMaster.examinationDate = examinationDate;
    examinationSupplyMaster.poOrderSupplierCode = this.poOrderSupplierCode;

    let mode = this._userSessionService.getSessionKey('link')['mode'];
    if (mode && mode == 3) {
      examinationSupplyMaster.examinationType = 3;
    }
    if (mode && mode == 2) {
      examinationSupplyMaster.examinationType = 2;
    }
    if (mode && mode == 1) {
      examinationSupplyMaster.examinationType = 1;
    }

    let ExaminationSupply = <ExaminationSupply>{}
    ExaminationSupply.examinationSupplyMaster = examinationSupplyMaster;
    ExaminationSupply.examinationSupplyDetails = examinationSupplys;
    this._ExaminationSupplyServiceService.addStrExaminationSupply(ExaminationSupply)

      .subscribe(c => {
        if (c.data) {
          this.ExaminationSupplyForm.get('serial').setValue(c.data[0].masterSerial)
          this.printExam(c.data[0]);
          this.NewExamination();
        }

      },
        error => console.log(error),
        () => {

        });


  }
  expirationDateClick(row) {
    if (this.storeActiveExpirationDate) {
      this._StockHelper.expirationDateValidationCheck(row);
    }
  }
  onpopupClose(parms?: any) {

  }
  //لجنة الفحص 
  examinationCommitteeEmps: any = [];
  getExaminationCommitteeForStore() {
    this._StoreExaminationCommitteeStpService.getStoreExaminationCommitteeStp(this.ExaminationSupplyForm.get('storeCode').value)
      .subscribe(
        t => {
          if (t.data.length > 0)
            this.examinationCommitteeEmps = t.data;
        },
        error => console.log(error),
        () => {
          if (this.examinationCommitteeEmps.length > 0) {
            this._toastService.activateMsg('هناك لجنة فحص تابعة لهذا المخزن تأكد من توقيع اللجنه اولا');
          }

        });
  }
  CheckQty() {
    if (this.hiddenQuantityFromExamination == 1) {
      for (var i = 0; i < this.items.length; i++) {
        if (+this.items[i].acceptQty != +this.items[i].number) {
          this.items[i]['reasonOfReject'] = ' غير مطابق للمواصفات';
        }
        this.items[i].remain = this.items[i].acceptQty;
        this.items[i].acceptQty = this.items[i].acceptQty;
        this.items[i].supplyQty = this.items[i].acceptQty;
      }
    }
  }
  handNumberReq: number;
  save() {
    //تاكيد توقيع جميع لجنة الاستلام والفحص    #######Azmio 29/9/2022########
    let examinationCommittee = <any>this._userSessionService.getSessionKey('ExaminationCommittee');
    // المخزن له لجنة ولسه مربطش اللجنه بامر التوريد
    if (this.selectexaminationCommitteeEmps != 2 && this.examinationCommitteeEmps.length > 0 && (!examinationCommittee || examinationCommittee.length == 0)) {
      this._toastService.activateMsg('يوجد موظفين لم يوقعوا في لجنة الاستلام والفحص');
      return
    }
    let empWithOutSignature: any;
    //ضاف اللجنه لامر التوريد بس موقعوش 
    if (this.selectexaminationCommitteeEmps != 2 && examinationCommittee && examinationCommittee.length > 0) {
      examinationCommittee.forEach(element => {
        if (!element.userSignatureConfirmed) {
          empWithOutSignature = element.code
          return;
        }
      });
    }
    ///لو فى موظف موقعش
    if (this.selectexaminationCommitteeEmps != 2 && empWithOutSignature) {
      this._toastService.activateMsg('يوجد موظفين لم يوقعوا في لجنة الاستلام والفحص', empWithOutSignature);
      return;
    } if (this.directAddFromExamination == 1) {
      this._modalService.activeTranslatedMesg('UI275').then(response => {
        if (response) {
          this.CheckQty();
          if (this.ExaminationSupplyForm.get('storeCode').value == (undefined || null)) {
            this._toastService.activateMsg('UI64');
            return;
          }
          if (this.handNumberReq == 1 &&
            (this.ExaminationSupplyForm.get('handNumber').value == undefined
              || this.ExaminationSupplyForm.get('handNumber').value == null)) {
            this._toastService.activateMsg('HANDNUMBERMSG');
            return;
          }
          this._userSessionService.setSessionKey("ExaminationSupplyResetPrint", 1);
          let examinationSupplys = [];
          for (var i = 0; i < this.items.length; i++) {
            let examinationSupplyDetails = <ExaminationSupplyDetails>{};
            examinationSupplyDetails.serial = (this.items[i].examSerial ? this.items[i].examSerial : (i + 1) * -1)
            if ((this.items[i].remain == (undefined || null)) ||
              (this.items[i].rejectQty == (undefined || null)) ||
              (this.items[i].acceptQty == (undefined || null)) ||
              (this.items[i].supplyQty == (undefined || null))) {
              this._toastService.activateMsg("UI31", this.items[i].code);
              return false;
            }
            if (this.items[i] && (+this.items[i]["supplyQty"] > +this.items[i]["remain"])) {
              this._toastService.activateMsg('UI111', this.items[i].code);
              return;
            }
            if (+this.items[i]["acceptQty"] > +this.items[i]["supplyQty"]) {
              this._toastService.activateMsg('UI13', this.items[i].code);
              return;
            }
            //============---------------validation on expiration ------------ 
            this.items = this.items.sort();
            this.items[i]['errorselected'] = 0
            //لو بيانات ناقصه
            if (this.items[i].expiry == true && this.storeActiveExpirationDate) {
              if (this.items[i].expirationDate == undefined || this.items[i].expirationDate == null || this.items[i].expirationDate == "") {
                this._toastService.activateMsg('WARNINGEXPIRATIONDATE', this.items[i]['code']);
                this.items.forEach(el => {
                  if (el.expirationDate == undefined || el.expirationDate == null || el.expirationDate == "") {
                    el.errorselected = 1
                  }
                }); return;
              }
              if (this.items[i].expirationDate < this._dateService.convertFromDateToNgBsObject(new Date())) {
                this._toastService.activateMsg('UI1212', this.items[i]['code']);
                this.items.forEach(el => {
                  if (el.expirationDate < this._dateService.convertFromDateToNgBsObject(new Date())) {
                    el.errorselected = 1
                  }
                });
                return false;
              }
              let date = new Date(); //-----تاريخ الصلاحيه

              let _vDate = this._dateService.convertFromNgBsToDate(this.items[i].expirationDate)
              if (_vDate < date) {
                this._toastService.activateMsg("UI1212", this.items[i]['code'])
                this.items[i]['errorselected'] = 1
                return;

              }
            }
            examinationSupplyDetails.itemCode = this.items[i].code;
            examinationSupplyDetails.quantity = +this.items[i].remain;
            examinationSupplyDetails.rejectQty = +this.items[i].rejectQty;
            examinationSupplyDetails.acceptQty = +this.items[i].acceptQty;
            examinationSupplyDetails.supplyQty = +this.items[i].supplyQty;
            examinationSupplyDetails.unitCode = this.items[i].unitCode;
            examinationSupplyDetails.giftFlag = this.items[i].giftFlag;
            examinationSupplyDetails.remain = +this.items[i].remain;
            examinationSupplyDetails.reasonOfReject = this.items[i].reasonOfReject;
            examinationSupplyDetails.patchCodeStr = this.items[i].patchCodeStr;


            /// calculate samll unit
            let smaillUnit = this.getSmallUnit(this.itemUnits, this.items[i].code);
            if (smaillUnit && smaillUnit.length > 0) {
              examinationSupplyDetails.smallUnitCode = smaillUnit[0].serial;
            }
            if (this.makeExaminationWithoutOrderSupply != 1 && this.items[0].poOrderSupplyMasterSerial == (undefined || null)) {
              this._toastService.activateMsg('UI175', this.items[i].code);
              return;
            }
            examinationSupplyDetails.poOrderSupplyMasterSerial = this.items[0].poOrderSupplyMasterSerial;
            examinationSupplys.push(examinationSupplyDetails);
          }
          //master
          let examinationSupplyMaster = <ExaminationSupplyMaster>{};
          let examinationDate = this._dateService.convertFromNgBsToDate(this.ExaminationSupplyForm.get('examinationDate').value);
          this.ExaminationSupplyForm.get('status').setValue(1)//abdo3/8/2024
          examinationSupplyMaster = this.ExaminationSupplyForm.value;
          examinationSupplyMaster.examinationDate = examinationDate;
          examinationSupplyMaster.poOrderSupplierCode = this.poOrderSupplierCode;
          let mode = this._userSessionService.getSessionKey('link')['mode'];
          if (mode && mode == 3) {
            examinationSupplyMaster.examinationType = 3;
          }
          if (mode && mode == 2) {
            examinationSupplyMaster.examinationType = 2;
          }
          if (mode && mode == 1) {
            examinationSupplyMaster.examinationType = 1;
          }
          let ExaminationSupply = <ExaminationSupply>{}
          ExaminationSupply.examinationSupplyMaster = examinationSupplyMaster;
          ExaminationSupply.examinationSupplyDetails = examinationSupplys;
          this._ExaminationSupplyServiceService.addStrExaminationSupply(ExaminationSupply)
            .subscribe(c => {
              if (c.data) {
                this.ExaminationSupplyForm.get('serial').setValue(c.data[0].masterSerial)
                this.printExam(c.data[0]);
              }
            },
              error => console.log(error),
              () => {
                this.items.forEach(element => {//9/5/2023
                  element.examinationSupplyCode = this.ExaminationSupplyForm.get('serial').value;
                });
                let formData = Object.assign({});
                formData = Object.assign(formData, this.DirectAddTransForm.value);
                formData.storeCode = this.ExaminationSupplyForm.get('storeCode').value;
                formData.supplierCode = this.ExaminationSupplyForm.get('supSupplierCode').value;
                formData.handNumber = this.ExaminationSupplyForm.get('handNumber').value;
                formData.discount = this.itemsInPoOrderSupplyListObj['discountOfMaster'];
                formData.discountType = this.itemsInPoOrderSupplyListObj['discountTypeOfMaster'];
                formData.masterAdditionalDiscountOutTax = this.itemsInPoOrderSupplyListObj['masterAdditionalDiscountOutTax'];
                formData.masterAdditionalDiscountType = this.itemsInPoOrderSupplyListObj['masterAdditionalDiscountType'];
                formData.totalNetCost = this.itemsInPoOrderSupplyListObj['totalNetCost'];
                this.myCompOneObj.mycustomclick(formData, this.items, this.itemUnits, 5204);
                this.NewExamination();
              });
        } else {
          this.saveExmaination();
        }
      });
    } else {
      this.saveExmaination();
    }
  }
  getModuleSettings() {

    this._userSessionService.subscribeToKey$('link')
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(link => {
        if (link.name = 'link') {
          this._userSessionService.subscribeToKey$('modulesSettings')
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((keys: any) => {
              if (keys.value) {
                this.stockModuleSettings = keys.value[`m_${40}`];
                this.defaultDiscountAttributes = this.stockModuleSettings['defaultDiscountAttribute'];
                this.handNumberReq = +this.stockModuleSettings['enterBillNumberIsMust'];
                this.selectexaminationCommitteeEmps = +this.stockModuleSettings['selectexaminationCommitteeEmps'];
                this.makeExaminationWithoutOrderSupply = +this.stockModuleSettings['makeExaminationWithoutOrderSupply'];
                this.hiddenQuantityFromExamination = +this.stockModuleSettings['hiddenQuantityFromExamination'];

                if (!this.addTaxToItemCostSetting) {
                  this.stockModuleSettings = keys.value[`m_${43}`]
                  this.addTaxToItemCostSetting = this.stockModuleSettings['addTaxToItemCost'];
                }
                if (!this.directAddFromExamination) {
                  this.stockModuleSettings = keys.value[`m_${60}`]
                  this.directAddFromExamination = this.stockModuleSettings['directAddFromExamination'];
                }
              }
            });

          if (!this.selectexaminationCommitteeEmps || !this.stockModuleSettings ||
            !this.defaultDiscountAttributes || !this.addTaxToItemCostSetting ||
            !this.directAddFromExamination || !this.hiddenQuantityFromExamination
          ) {
            this._DirectAddTransService.getStockModuleSettings({ moduleId: 40 })
              .pipe(takeUntil(this.ngUnsubscribe))
              .subscribe(c => {
                if (c.data && c.data.length > 0) {
                  this.stockModuleSettings = c.data[0];
                  if (this.stockModuleSettings) {
                    this.defaultDiscountAttributes = this.stockModuleSettings['defaultDiscountAttribute'];
                    this.handNumberReq = +this.stockModuleSettings['enterBillNumberIsMust'];
                    this.selectexaminationCommitteeEmps = +this.stockModuleSettings['selectexaminationCommitteeEmps'];
                    this.makeExaminationWithoutOrderSupply = +this.stockModuleSettings['makeExaminationWithoutOrderSupply'];
                    this.hiddenQuantityFromExamination = +this.stockModuleSettings['hiddenQuantityFromExamination'];
                  }
                }
              });
            this._DirectAddTransService.getStockModuleSettings({ moduleId: 61 })
              .pipe(takeUntil(this.ngUnsubscribe))
              .subscribe(c => {
                if (c.data && c.data.length > 0) {
                  this.stockModuleSettings = c.data[0];
                  if (this.stockModuleSettings) {
                    this.defaultDiscountAttributes = this.stockModuleSettings['defaultDiscountAttribute'];
                    this.handNumberReq = +this.stockModuleSettings['enterBillNumberIsMust'];

                  }
                }
              });
            this._DirectAddTransService.getStockModuleSettings({ moduleId: 43 })
              .pipe(takeUntil(this.ngUnsubscribe))
              .subscribe(c => {
                if (c.data && c.data.length > 0) {
                  this.stockModuleSettings = c.data[0];
                  if (this.stockModuleSettings) {
                    this.addTaxToItemCostSetting = this.stockModuleSettings['addTaxToItemCost'];
                  }
                }
              });
            this._DirectAddTransService.getStockModuleSettings({ moduleId: 60 })
              .pipe(takeUntil(this.ngUnsubscribe))
              .subscribe(c => {
                if (c.data && c.data.length > 0) {
                  this.stockModuleSettings = c.data[0];
                  if (this.stockModuleSettings) {
                    this.directAddFromExamination = this.stockModuleSettings['directAddFromExamination'];
                  }
                }
              });
          }
        }
      });

  }

  deleteRow(row) {
    let ind = this.items.indexOf(row);
    this.items.splice(ind, 1);

  }


  cancel(showToast = true) {
    this._goBack();
  }



  _goBack(): void {
    this._location.back();
  }


  queryUIKey(key: string): boolean {
    return this._userSessionService.queryUIKey(key, this.UITreeKey);
  }
  queryVisitedUI(key: string): boolean {
    return this._userSessionService.queryVisitedUI(key, this.UITreeKey);
  }

}
